export const PROFILE_PATH = "/profile" as const;

export const profileTabs = ["profile", "security", "notification-settings", "notification-center", "support"] as const;

export type ProfileTabId = (typeof profileTabs)[number];

export const DEFAULT_PROFILE_TAB: ProfileTabId = "profile";

export const getProfileTabHref = (tab: ProfileTabId = DEFAULT_PROFILE_TAB) => {
  const params = new URLSearchParams();
  params.set("tab", tab);
  return `${PROFILE_PATH}?${params.toString()}`;
};

export const parseProfileTab = (search: string): ProfileTabId => {
  const value = new URLSearchParams(search.startsWith("?") ? search : `?${search}`).get("tab");
  if (profileTabs.includes((value ?? "").toLowerCase() as ProfileTabId)) {
    return (value as ProfileTabId) ?? DEFAULT_PROFILE_TAB;
  }
  return DEFAULT_PROFILE_TAB;
};

export const isProfileRoute = (pathname: string) => pathname === PROFILE_PATH;

export const isProfileTabActive = (
  pathname: string,
  search: string,
  targetTab: ProfileTabId
) => isProfileRoute(pathname) && parseProfileTab(search) === targetTab;

export const getProfileTabFromHref = (href: string): ProfileTabId | null => {
  try {
    const url = new URL(href, "http://local");
    const tab = url.searchParams.get("tab") ?? undefined;
    if (tab && profileTabs.includes(tab as ProfileTabId)) {
      return tab as ProfileTabId;
    }
    return null;
  } catch {
    return null;
  }
};
